import script from "./WorkspaceSelectOption.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceSelectOption.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceSelectOption.vue?vue&type=style&index=0&id=d82587be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d82587be"]])

export default __exports__